import { render, staticRenderFns } from "./Input-Currency-Global.vue?vue&type=template&id=28560319&"
import script from "./Input-Currency-Global.vue?vue&type=script&lang=js&"
export * from "./Input-Currency-Global.vue?vue&type=script&lang=js&"
import style0 from "./Input-Currency-Global.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
